import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Login from "../views/auth/Login";
import Dashboard from "../views/pages/Dashboard";
import RegistrationList from "../views/pages/registration/RegistrationList";
import AddProduct from "../views/pages/product/AddProduct";
import ProductList from "../views/pages/product/ProductList";
import ChangePassword from "../views/pages/profile/ChangePassword";
import SellerProfile from "../views/pages/seller/SellerProfile";
import OrderList from "../views/pages/order/OrderList";
import OrderDetails from "../views/pages/order/OrderDetails";
import Invoice from "../views/pages/order/Invoice";
import AddVendor from "../views/pages/vendor/AddVendor";
import VendorList from "../views/pages/vendor/VendorList";
import MyOrdersList from "../views/pages/my_orders/MyOrdersList";
import ActivateEcomProduct from "../views/pages/product/ActivateEcomProduct";
import { getCookie } from "../utils/CookieAction";
import AddVariant from "../views/pages/variant/Addvariant";
import EditProduct from "../views/pages/product/EditProduct";
import PoGenerate from "../views/pages/po_generate/PoGenerate";
import MyOrderDetails from "../views/pages/my_orders/MyOrderDetails";
import { INDIAN_MSME_USER_TOKEN } from "../utils/Constants";
import POList from "../views/pages/po_generate/POList";
import Payment from "../views/pages/po_generate/Payment";
import PoOrderList from "../views/pages/order/PoOrderList";
import PoOrderItems from "../views/pages/po_generate/PoOrderItems";
import PaymentHistory from "../views/pages/Payment/PaymentHistory";
import ReferralList from "../views/pages/referral/ReferralList";
import EditSellerProfile from "../views/pages/seller/EditSellerProfile";
import NotificationList from "../views/pages/notification/NotificationList";
import DeliveryArea from "../views/pages/delivery_area/DeliveryAreaList";
import BuyerInvoice from "../views/pages/order/BuyerInvoice";
import OrderPvHistory from "../views/pages/pv/OrderPvHistory";
import BSPanelAccess from "../views/pages/bs-panel-access/BSPanelAccess";
import BSList from "../views/pages/bs-list/BSList";
import MyTeam from "../views/pages/my_team/MyTeam";
import MyTree from "../views/pages/my-tree/MyTree";
import BSRequest from "../views/pages/bs_request/BSRequest";
import BuyerRequest from "../views/pages/bs_request/BuyerRequest";
import ErmCard from "../views/pages/card/ErmCard";
import CreateBuyer from "../views/pages/create_buyer/CreateBuyer";
import PosPage from "../views/pages/pos/PosPage";
import MyBuyerList from "../views/pages/bs-list/MyBuyerList";

const PageRoutes = () => {
  const navigate = useNavigate();

  const url = window.location.href;

  useEffect(() => {
    const tokens = getCookie(INDIAN_MSME_USER_TOKEN);
    if (!url.includes("continue-to-login")) {
      if (tokens) {
        const parsedToken = JSON.parse(tokens);
        if (!parsedToken) {
          navigate("/");
        }
      } else {
        navigate("/");
      }
    }
  }, [navigate]);

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/continue-to-login/:id" element={<BSPanelAccess />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/registration-list" element={<RegistrationList />} />
      <Route path="/add-product" element={<AddProduct />} />
      <Route path="/product-list" element={<ProductList />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/profile" element={<SellerProfile />} />
      <Route path="/my-order-details/:id" element={<MyOrderDetails />} />
      <Route path="/invoice/:id" element={<Invoice />} />
      <Route path="/add-variant/:id" element={<AddVariant />} />
      <Route path="/add-vendor" element={<AddVendor />} />
      <Route path="/vendor-list" element={<VendorList />} />
      <Route path="/po-generate" element={<PoGenerate />} />
      <Route path="/my-orders/:myOrderStatus" element={<MyOrdersList />} />
      <Route path="/orders/:orderStatus" element={<OrderList />} />
      <Route path="/po-orders" element={<PoOrderList />} />
      <Route path="/po-orders-items/:id" element={<PoOrderItems />} />
      <Route path="edit-product/:id" element={<EditProduct />} />
      <Route
        path="/activate-eCom-product/:id"
        element={<ActivateEcomProduct />}
      />
      <Route path="/order-details/:id" element={<OrderDetails />} />
      <Route path="/po-list/:poOrderStatus" element={<POList />} />
      <Route path="/payment/:id/:price" element={<Payment />} />
      <Route path="/payment-history" element={<PaymentHistory />} />
      <Route path="/referral-list" element={<ReferralList />} />
      <Route path="/edit-seller-profile" element={<EditSellerProfile />} />
      <Route path="/notification" element={<NotificationList />} />
      <Route path="/delivery-area" element={<DeliveryArea />} />
      <Route path="/buyer-invoice/:id" element={<BuyerInvoice />} />
      <Route path="/order-pv-history" element={<OrderPvHistory />} />
      <Route path="/bs-list" element={<BSList />} />
      <Route path="/team-list" element={<MyTeam />} />
      <Route path="/my-tree" element={<MyTree />} />
      <Route path="/seller-request" element={<BSRequest />} />
      <Route path="/buyer-request" element={<BuyerRequest />} />
      <Route path="/erm-card" element={<ErmCard />} />
      <Route path="/create-buyer" element={<CreateBuyer />} />
      <Route path="/pos" element={<PosPage />} />
      <Route path="/my-buyer-list" element={<MyBuyerList />} />
    </Routes>
  );
};

export default PageRoutes;
